<template>
  <div class="hvh-card--rounded v-sheet theme--light">
    <h2 class="mb-4" v-if="text">{{ text }}</h2>
    <div class="hvh-relative">
      <hvh-chart :visualization="visualization" :options="chartOptions" :isEditMode="true" :height="height" @item-clicked="$emit('checked-changed', $event, data)" @wheel="scroll" ref="chart" />
      <hvh-vertical-scroll-bar :total="data.length" :displayed="displayedBarChartData" v-model="scrollBarValue" v-if="data.length > displayedBarChartData" :style="{ position: 'absolute', margin: '0', top: 0, right: 0, bottom: 0 }" />
      <h4 class="text-xs-center hvh-h7" v-if="label">{{ label }}</h4>
      <loader v-if="isFiltering" />
    </div>
  </div>
</template>

<script>
import { isTextWithinLimit, splitSentanceToWords, trimDotEnd } from '../../libraries/charts/chartCommon';
import { customNumberFormat, Debouncer, hashCode } from '../../libraries/common';
import { merge } from 'lodash';
export default {
  props: ['data', 'filterObject', 'text', 'isChecked', 'nameField', 'valueField', 'options', 'isFiltering', 'menuOptions', 'allChartTypes', 'height', 'labelInside', 'label'],
  data() {
    return {
      displayedBarChartData: 10,
      scrollBarValue: 0,
      debouncer: new Debouncer(2000),
    }
  },
  methods: {
    scroll(event) {
      var oldValue = this.scrollBarValue;
      this.scrollBarValue += event.wheelDeltaY < 0 ? 1 : -1;
      this.scrollBarValue = Math.max(0, Math.min(this.scrollBarValue, this.data.length - this.displayedBarChartData));
      if (Math.abs(oldValue - this.scrollBarValue) > 0 || event.ctrlKey) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
  },
  computed: {
    visualization() {
      var dataLength = Math.min(this.data.length, this.displayedBarChartData);
      return {
        visualization_type: 'horizontalbarchart',
        name_field: this.nameField || 'diagnosis',
        value_field: this.valueField,
        data: this.data
          .filter((_, ind) => ind >= this.scrollBarValue && ind < this.scrollBarValue + dataLength)
          .map(f => ({
            ...f,
            ...(this.isChecked && this.isChecked(f) ? { color: '#4ec1ef' } : {}),
            unchecked: this.isChecked && this.data.find(f => this.isChecked(f)) && !this.isChecked(f)
          })),
      };
    },
    filterHash() {
      return hashCode(this.filterObject || {});
    },
    chartOptions() {
      var labelInsideOptions = {
        grid: {
          bottom: '0%',
          containLabel: true,
          left: '20px',
          right: '30px',
          top: '0%'
        },
        yAxis: {
          axisLabel: {
            formatter: value => {
              var isWithinLimit = isTextWithinLimit(this.$el.offsetWidth - 20);
              var words = splitSentanceToWords(value);

              const splitted = splitSentanceToWords(words.map(word => ({ word })), isWithinLimit, 2);
              if (splitted[1]) {
                splitted[1] = trimDotEnd(splitted[1], isWithinLimit);
              }
              return splitted.map(f => f.sentance).join('\n');
            },
            inside: true,
          },
          axisTick: {
            show: false
          },
        },
      };
      var options = {
        grid: {
          bottom: '0%',
          containLabel: true,
          top: '0%'
        },
        yAxis: {
          axisTick: {
            show: false
          },
        },
      };

      var tooltip = {
        tooltip: {
          formatter: (params) => {
            var marker = '<dt style="width:10px;height:10px;display:inline-block;margin-right:5px;">' +
              '<svg viewBox="0 0 12 12"><path fill="' + params.color + '" d="M0 0h12v12H0z"></path></svg>' +
              '</dt>';

            var label = this.label ? `${this.label}: ` : '';
            return '<div style="max-width:400px;white-space:pre-wrap;">' +
              params.name + '<br>' +
              marker + ' ' + label + customNumberFormat(params.data.data[this.valueField]) + '<br>' +
              '<div>';
          }
        }
      };

      return merge(this.labelInside ? labelInsideOptions : options, tooltip, (this.options || {}));
    },
  },
  watch: {
    filterHash() {
      this.debouncer.clear().push(() => this.$emit('refresh-data', this.filterObject));
    },
  },
  mounted() {
    this.$emit('chart-created', this.filterObject);
  }
}
</script>